import * as React from "react";
import Stack from "@mui/material/Stack";
import moment from "moment/moment";
import { Grid } from "@mui/material";
import axios from "axios";
import { genURL, genURLTEST } from "../../../_getjson";
import CustomBackdrop from "../../../Components/CustomBackdrop/Barckdrop";
import CustomDataGrid from "../../../Components/CustomDataGrid/CustomDataGrid";
import Selectsaleref2sub from "./Selectsaleref2sub";
import FullScreen from "../../../PopUp/FullScreendialogs/FullScreen";

const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },

  {
    field: "docNo",
    headerName: "เลขที่เอกสาร",
    width: 200,
    editable: false,
  },
  {
    field: "docDate",
    headerName: "วันที่เอกสาร",
    width: 150,
    editable: false,
  },
  {
    field: "acceptDate",
    headerName: "ลงวันที่",
    width: 150,
    editable: false,
  },

  {
    field: "saleName",
    headerName: "พนักงานขาย",
    width: 200,
    editable: false,
  },
  {
    field: "creditCode",
    headerName: "รหัสเครดิต",
    width: 200,
    editable: false,
  },
  {
    field: "remark",
    headerName: "หมายเหตุ",
    width: 200,
    editable: false,
  },
  ,
  {
    field: "currency",
    headerName: "สกุลเงิน",
    width: 200,
    editable: false,
  },
  {
    field: "total",
    headerName: "รวมเงินทั้งสิ้น",
    width: 200,
    editable: false,
  },
  {
    field: "type",
    headerName: "ประเภท",
    width: 200,
    editable: false,
  },
];

export default function Selectsaleref2(props) {
  const [state, setState] = React.useState({
    openbackdrop: false,
    openFullScreenDialog: false,
    titleFullScreenDialog: "เลือกรายการย่อย",
    selectRow: [],
    rows: [],
  });
  React.useEffect(() => {
    loadData();

    return () => {};
  }, []);

  async function loadData() {
    await setState((prevState) => ({ ...prevState, openbackdrop: true }));

    let rs = await axios.get(
      genURL("CSV_SALEREFDOCNO2/searchData?arCode=" + props.arCode)
    );
    //let rs = await axios.get(genURLTEST("searchData?arCode=" + props.arCode))
    // let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}&top=${state.top}`))
    let element = [];
    console.log(rs);

    if (rs.data.length > 0) {
      //  console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          docDate: moment(rs.data[index].DOCDATE).format("L"),
          acceptDate: moment(rs.data[index].DUEDATE).format("L"),
          /* The `docNo` field in the code is used as a property in the Selectsaleref2
                    component. It is being displayed as a column header in the CustomDataGrid
                    component with the header name 'เลขที่เอกสาร' (Document Number). This field is
                    not editable and is part of the data rows that are fetched and displayed in the
                    grid. */
          docNo: rs.data[index].DOCNO,
          saleName: rs.data[index].SALENAME,
          remark: rs.data[index].REMARK,
          currency: rs.data[index].CURRNAME,
          total: rs.data[index].DEBTAMOUNT,
          type: rs.data[index].TYPE,
          creditCode: rs.data[index].CREDITCODE,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      await setState((prevState) => ({ ...prevState, rows: element }));
    } else {
      await setState((prevState) => ({
        ...prevState,
        rows: [],
        openbackdrop: false,
      }));
    }
    await setState((prevState) => ({ ...prevState, openbackdrop: false }));
  }
  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = async (e) => {
    // await props.Dataselect(e)
    await setState((prevState) => ({
      ...prevState,
      openFullScreenDialog: true,
      selectRow: e,
    }));
  };
  const CloseDialog = () => {
    setState((prevState) => ({ ...prevState, openFullScreenDialog: false }));
    // await props.Dataselect(e)
  };

  const dataSubSelect = (e) => {
    setState((prevState) => ({ ...prevState, openFullScreenDialog: false }));
    props.Dataselect(e);
  };
  return (
    <>
      <FullScreen
        open={state.openFullScreenDialog}
        title={state.titleFullScreenDialog}
        closeDialog={(e) => CloseDialog(e)}
      >
        <Selectsaleref2sub
          docNo={state.selectRow}
          from="Selectsaleref2sub"
          Dataselect={(e) => dataSubSelect(e)}
        />
      </FullScreen>

      <Stack spacing={2} direction="row" sx={{ padding: 2 }}>
        {/* */}
        {state.rows.length > 0 ? (
          <CustomDataGrid
            datacolumns={columns}
            datarows={state.rows}
            rowHeight={38}
            Dataintable={(e) => resData(e)}
            Dataintableremove={(e) => removeresData(e)}
            startRow={1}
            option={[{ add: false, del: false, select: true }]}
            checkboxSelection
            onRowClick={(e) => selcetRow([e.row])}
            // disableColumnSelector
            Dataselect={(e) => selcetRow(e)}
            RowsModelChange={(_) => console.log("RowsModelChange")}
            from={"m" + props.from}
          />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} textAlign={"center"}>
              ไม่พบข้อมูล
            </Grid>
          </Grid>
        )}
        <CustomBackdrop open={state.openbackdrop} />
      </Stack>
    </>
  );
}
